import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FixedFeeTermsRowLoadingDesktop } from './desktop';
import { FixedFeeTermsRowLoadingMobile } from './mobile';

export const FixedFeeTermsRowLoading: React.FC = () => {
  return useBreakpointValue({
    base: <FixedFeeTermsRowLoadingMobile />,
    sm: <FixedFeeTermsRowLoadingMobile />,
    lg: <FixedFeeTermsRowLoadingDesktop />,
  });
};
